import mqtt from 'mqtt';

const MqttPlugin = {
  install(Vue, options = {}) {
    // 默认配置
    const defaults = {
      brokerUrl: 'ws://test.mosquitto.org:8080/mqtt',
      options: {
        clientId: 'client_' + Math.random().toString(16).substr(2, 8),
        keepalive: 60,
        clean: true,
        reconnectPeriod: 5000,
        connectTimeout: 30000,
      },
    };

    // 合并配置
    const config = {
      brokerUrl: options.brokerUrl || defaults.brokerUrl,
      options: { ...defaults.options, ...options.options },
    };

    // 创建客户端
    const client = mqtt.connect(config.brokerUrl, config.options);
    const handlers = {};

    // 全局MQTT对象
    const mqttObj = {
      client,
      isConnected: false,

      // 订阅主题
      subscribe(topic, callback, opts = { qos: 0 }) {
        client.subscribe(topic, opts, (err) => {
          if (!err) {
            if (!handlers[topic]) handlers[topic] = [];
            handlers[topic].push(callback);
            console.log('已订阅主题', topic);
          }
        });
      },

      // 取消订阅
      unsubscribe(topic, callback) {
        if (handlers[topic]) {
          if (callback) {
            const index = handlers[topic].indexOf(callback);
            if (index > -1) handlers[topic].splice(index, 1);
          } else {
            delete handlers[topic];
          }
          client.unsubscribe(topic);
        }
      },

      // 发布消息
      publish(topic, message, opts = { qos: 0 }) {
        client.publish(topic, message, opts);
      },

      // 断开连接
      disconnect() {
        client.end();
      },
    };

    // 消息处理
    client.on('message', (topic, message) => {
      if (handlers[topic]) {
        handlers[topic].forEach((cb) => cb(message.toString()));
      }
    });

    // 连接状态
    client.on('connect', () => {
      mqttObj.isConnected = true;
      console.log('[MQTT] Connected');
      // 重新订阅已存在的主题
      Object.keys(handlers).forEach((topic) => {
        client.subscribe(topic);
        console.log('重新订阅已存在的主题:', topic);
      });
    });

    client.on('reconnect', () => {
      mqttObj.isConnected = false;
      console.log('[MQTT] Reconnecting...');
    });

    client.on('close', () => {
      mqttObj.isConnected = false;
      console.log('[MQTT] Disconnected');
    });

    client.on('error', (err) => {
      console.error('[MQTT] Error:', err);
    });

    // 挂载到Vue原型
    Vue.prototype.$mqtt = mqttObj;
  },
};

export default MqttPlugin;
